import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Notification } from './notification.model';
import { Subscription } from 'rxjs';
import { AlertCircle, AlertTriangle, CheckCircle2, Info, LucideAngularModule, X } from 'lucide-angular';
import { NotificationService } from '@app/shared/notification/notification.service';

@Component({
  selector: 'app-notification',
  standalone: true,
  imports: [CommonModule, LucideAngularModule],
  templateUrl: './notification.component.html'
})
export class NotificationComponent implements OnInit, OnDestroy {
  notifications: (Notification & { isClosing?: boolean })[] = [];
  private subscription: Subscription = new Subscription();

  constructor(private notificationService: NotificationService) {}

  ngOnInit(): void {
    this.subscription = this.notificationService.getNotifications().subscribe((notifications) => {
      this.notifications = notifications;
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  close(id: string): void {
    // Mark notification as closing for animation
    const notification = this.notifications.find(n => n.id === id);
    if (notification) {
      notification.isClosing = true;
      // Delay actual removal to allow animation to complete
      setTimeout(() => {
        this.notificationService.close(id);
      }, 300);
    }
  }

  protected readonly CheckCircle2 = CheckCircle2;
  protected readonly AlertCircle = AlertCircle;
  protected readonly AlertTriangle = AlertTriangle;
  protected readonly Info = Info;
  protected readonly X = X;
}
